import { ViewModel } from './_vm'

import FormStore from './store/_form-store'
import SelectTemplate from './_selectTemplate'
import UlLiTemplate from './_ulLiTemplate'

/**
 * FormUl // セレクトのjs
 *
 * @returns {undefined}
 */
export class FormUl extends ViewModel {
  constructor($element, controller) {
    super(FormUl.name(), $element, controller)
    this.formName = this.$element.attr('name')

    // イベントの登録
    // this.$element.on('change', () => this.select())
    this.on(`FormUl`, () => this.render())

    // 様子見
    this.render()
  }

  static name() {
    return 'FormUl'
  }

  static className() {
    return '.js-kaigai-form-ul'
  }

  render() {
    this.option()
    this.hook('GadgetDropdownSelect')
    // this.trigger(`GadgetDropdownSelect`)
    const val = String(FormStore.getData(this.formName))
    this.$element.val(val)
  }

  /**
   * option // データが取れれば選択肢を追加する
   */
  option() {
    const list = this.list()
    if (list === '') return
    this.$element.empty()
    this.$element.append(list)
  }

  /**
   * list // 選択肢のhtmlを取得
   */
  list() {
    const current = FormStore.getData(this.formName)
    const data = FormStore.selectList(this.formName)
    return UlLiTemplate.ul(data, current)
  }

  //   select() {
  //     const item = $('option:selected', this.$element).val() ? $('option:selected', this.$element).val() : null

  //     FormStore.FormUl(this.formName, item)
  //     this.trigger(`FormUl:${this.formName}`)
  //     FormStore.validation(this.formName)
  //     this.trigger('Form:errors')
  //   }
}
